import { bool, number, string } from 'prop-types';

const circuitBasicInformationPropTypes = {
  id: number.isRequired,
  name: string.isRequired,
  active: bool.isRequired,
  description: string.isRequired,
  createDate: number.isRequired,
  lastUpdate: number.isRequired,
};

export default circuitBasicInformationPropTypes;
